'use strict';

(function () {

const translations = {
    es: {
        countdown_title: "El lanzamiento",
        products_title: "DROP 001",
        no_products: "No hay productos cargados en la colección.",
        add_to_cart: "AÑADIR AL CARRITO",
        buy_now: "COMPRAR AHORA",
        qty_label: "CANTIDAD",
        trust_shipping: "ENVÍO GRATIS DESDE 55€",
        trust_drop: "DROP LIMITADO 2026",
        trust_returns: "15 DÍAS DE DEVOLUCIÓN",
        related_title: "COMPLETA EL DROP",
        size_guide_title: "GUÍA DE TALLAS",
        sold_out: "AGOTADO",
        drop_locked: "DISPONIBLE 17/08 · 17:47",
        drop_soon: "PRÓXIMAMENTE",
        drop_live: "SHOP NOW",
        details_title: "DETALLES DEL PRODUCTO",
        details_fallback: "Detalles clasificados.",
        shipping_title: "ENVÍOS",
        shipping_body: "Cada pedido se prepara desde dentro, con el cuidado de la familia. Gastos de envío calculados en la pantalla de pago.",
        marquee_heart: 'ALWAYS FROM THE HEART <span class="marquee__sep">·</span> ALWAYS FROM THE HEART <span class="marquee__sep">·</span> ALWAYS FROM THE HEART <span class="marquee__sep">·</span>&nbsp;',
        marquee_shipping: 'ENVÍOS GRATIS A PARTIR DE 55 € <span class="marquee__sep">·</span> ENVÍOS GRATIS A PARTIR DE 55 € <span class="marquee__sep">·</span> ENVÍOS GRATIS A PARTIR DE 55 € <span class="marquee__sep">·</span>&nbsp;',
        marquee_line_html: 'ALWAYS FROM THE HEART <span class="top-marquee__sep">·</span> ENVÍOS GRATIS DESDE 55€ <span class="top-marquee__sep">·</span> DROP 17/08/2026 <span class="top-marquee__sep">·</span> ',
        index_h1: "47PRIVATE — STREETWEAR ESPAÑOL · REVELATION 2026",
        footer_manifesto_heading: "ALWAYS FROM THE HEART",
        footer_manifesto_text: "No hacemos prendas para todos. Cada pieza sale en unidades contadas, hecha desde dentro y sin restock. Si la llevas, formas parte de la familia.",
        footer_manifesto_sign: "ALWAYS FROM THE HEART",
        legal_privacy: "Política de Privacidad",
        legal_terms: "Términos y Condiciones",
        legal_refund: "Política de Devoluciones",
        legal_shipping: "Política de Envíos",
        legal_notice: "Aviso Legal",
        footer_stamp: "© 2026 47PRIVATE · TODOS LOS DERECHOS RESERVADOS",
        popup_pre: "OFERTA EXCLUSIVA",
        popup_title_html: "ÚNETE AL<br>CLUB PRIV47E",
        popup_sub_html: 'SUSCRÍBETE Y OBTÉN UN <span class="popup-highlight">10% DE DESCUENTO</span><br>EN TU PRIMERA COMPRA',
        popup_placeholder: "Tu correo electrónico",
        popup_submit: "SUSCRIBIRME",
        popup_legal: "* Al suscribirte aceptas recibir comunicaciones comerciales de 47Private. Puedes darte de baja en cualquier momento.",
        popup_sending: "ENVIANDO...",
        popup_welcome: "✓ ¡DENTRO! REVISA TU CORREO",
        popup_error: "ERROR",
        btn_add_index: "AÑADIR",
        cart_title: "CARRITO",
        cart_product: "PRODUCTO",
        cart_qty: "CANTIDAD",
        cart_total: "TOTAL",
        cart_remove: "ELIMINAR",
        cart_subtotal: "SUBTOTAL",
        cart_shipping_note: "LOS GASTOS DE ENVÍO SE CALCULAN EN LA PANTALLA DE PAGO.",
        cart_update: "ACTUALIZAR",
        cart_checkout: "PASAR POR CAJA",
        cart_empty_msg: "TU CARRITO ESTÁ VACÍO.",
        cart_continue: "VOLVER AL DROP",
        footer_subscribe_label: "RECIBE OFERTAS EXCLUSIVAS",
        footer_subscribe_placeholder: "Tu correo",
        footer_subscribe_btn: "SUSCRIBIRME →",
        cookie_title: "PRIV47E // COOKIES",
        cookie_text: "USAMOS COOKIES PARA MEDIR EL RENDIMIENTO DE LA TIENDA Y MEJORAR TU EXPERIENCIA. ¿LAS ACEPTAS?",
        cookie_accept: "ACEPTAR",
        cookie_reject: "DENEGAR",
        footer_subscribe_desc: "ÚNETE A LA FAMILIA. ACCESO ANTICIPADO A LOS DROPS Y CONTENIDO EXCLUSIVO DIRECTAMENTE EN TU CORREO.",
        footer_sending: "ENVIANDO...",
        footer_welcome: "✓ SUSCRITO",
        footer_error: "ERROR",
        select_options: "SELECCIONA TALLA",
        add_error_generic: "ERROR AL AÑADIR",
        added_ok: "✓ ALL IN"
    },
    en: {
        countdown_title: "The Launch",
        products_title: "DROP 001",
        no_products: "No products loaded in the collection.",
        add_to_cart: "ADD TO CART",
        buy_now: "BUY NOW",
        qty_label: "QUANTITY",
        trust_shipping: "FREE SHIPPING FROM 55€",
        trust_drop: "LIMITED DROP 2026",
        trust_returns: "15-DAY RETURNS",
        related_title: "COMPLETE THE DROP",
        size_guide_title: "SIZE GUIDE",
        sold_out: "SOLD OUT",
        drop_locked: "AVAILABLE 17/08 · 17:47",
        drop_soon: "COMING SOON",
        drop_live: "SHOP NOW",
        details_title: "PRODUCT DETAILS",
        details_fallback: "Classified details.",
        shipping_title: "SHIPPING",
        shipping_body: "Every order is prepared in-house, with the care of the family. Shipping costs are calculated at checkout.",
        marquee_heart: 'ALWAYS FROM THE HEART <span class="marquee__sep">·</span> ALWAYS FROM THE HEART <span class="marquee__sep">·</span> ALWAYS FROM THE HEART <span class="marquee__sep">·</span>&nbsp;',
        marquee_shipping: 'FREE SHIPPING FROM 55 € <span class="marquee__sep">·</span> FREE SHIPPING FROM 55 € <span class="marquee__sep">·</span> FREE SHIPPING FROM 55 € <span class="marquee__sep">·</span>&nbsp;',
        marquee_line_html: 'ALWAYS FROM THE HEART <span class="top-marquee__sep">·</span> FREE SHIPPING FROM 55€ <span class="top-marquee__sep">·</span> DROP 17/08/2026 <span class="top-marquee__sep">·</span> ',
        index_h1: "47PRIVATE — SPANISH STREETWEAR · REVELATION 2026",
        footer_manifesto_heading: "ALWAYS FROM THE HEART",
        footer_manifesto_text: "We don't make clothes for everyone. Every piece drops in counted units, made from within and with no restock. If you wear it, you're part of the family.",
        footer_manifesto_sign: "ALWAYS FROM THE HEART",
        legal_privacy: "Privacy Policy",
        legal_terms: "Terms & Conditions",
        legal_refund: "Refund Policy",
        legal_shipping: "Shipping Policy",
        legal_notice: "Legal Notice",
        footer_stamp: "© 2026 47PRIVATE · ALL RIGHTS RESERVED",
        popup_pre: "EXCLUSIVE OFFER",
        popup_title_html: "JOIN THE<br>PRIV47E CLUB",
        popup_sub_html: 'SUBSCRIBE AND GET <span class="popup-highlight">10% OFF</span><br>YOUR FIRST ORDER',
        popup_placeholder: "Your email address",
        popup_submit: "SUBSCRIBE",
        popup_legal: "* By subscribing you agree to receive marketing emails from 47Private. You can unsubscribe at any time.",
        popup_sending: "SENDING...",
        popup_welcome: "✓ YOU'RE IN! CHECK YOUR INBOX",
        popup_error: "ERROR",
        btn_add_index: "ADD",
        cart_title: "CART",
        cart_product: "PRODUCT",
        cart_qty: "QUANTITY",
        cart_total: "TOTAL",
        cart_remove: "REMOVE",
        cart_subtotal: "SUBTOTAL",
        cart_shipping_note: "SHIPPING COSTS ARE CALCULATED AT CHECKOUT.",
        cart_update: "UPDATE",
        cart_checkout: "CHECKOUT",
        cart_empty_msg: "YOUR CART IS EMPTY.",
        cart_continue: "RETURN TO DROP",
        footer_subscribe_label: "GET EXCLUSIVE OFFERS",
        footer_subscribe_placeholder: "Your email",
        footer_subscribe_btn: "SUBSCRIBE →",
        cookie_title: "PRIV47E // COOKIES",
        cookie_text: "WE USE COOKIES TO MEASURE STORE PERFORMANCE AND IMPROVE YOUR EXPERIENCE. DO YOU ACCEPT?",
        cookie_accept: "ACCEPT",
        cookie_reject: "DENY",
        footer_subscribe_desc: "JOIN THE FAMILY. EARLY ACCESS TO DROPS AND EXCLUSIVE CONTENT STRAIGHT TO YOUR INBOX.",
        footer_sending: "SENDING...",
        footer_welcome: "✓ SUBSCRIBED",
        footer_error: "ERROR",
        select_options: "SELECT SIZE",
        add_error_generic: "ADD FAILED",
        added_ok: "✓ ALL IN"
    },
    fr: {
        countdown_title: "Le Lancement",
        products_title: "DROP 001",
        no_products: "Aucun produit chargé dans la collection.",
        add_to_cart: "AJOUTER AU PANIER",
        buy_now: "ACHETER",
        qty_label: "QUANTITÉ",
        trust_shipping: "LIVRAISON GRATUITE DÈS 55€",
        trust_drop: "DROP LIMITÉ 2026",
        trust_returns: "15 JOURS DE RETOUR",
        related_title: "COMPLÈTE LE DROP",
        size_guide_title: "GUIDE DES TAILLES",
        sold_out: "ÉPUISÉ",
        drop_locked: "DISPONIBLE 17/08 · 17:47",
        drop_soon: "BIENTÔT",
        drop_live: "SHOP NOW",
        details_title: "DÉTAILS DU PRODUIT",
        details_fallback: "Détails classifiés.",
        shipping_title: "LIVRAISON",
        shipping_body: "Chaque commande est préparée en interne, avec le soin de la famille. Frais de port calculés au paiement.",
        marquee_heart: 'ALWAYS FROM THE HEART <span class="marquee__sep">·</span> ALWAYS FROM THE HEART <span class="marquee__sep">·</span> ALWAYS FROM THE HEART <span class="marquee__sep">·</span>&nbsp;',
        marquee_shipping: 'LIVRAISON GRATUITE DÈS 55 € <span class="marquee__sep">·</span> LIVRAISON GRATUITE DÈS 55 € <span class="marquee__sep">·</span> LIVRAISON GRATUITE DÈS 55 € <span class="marquee__sep">·</span>&nbsp;',
        marquee_line_html: 'ALWAYS FROM THE HEART <span class="top-marquee__sep">·</span> LIVRAISON GRATUITE DÈS 55€ <span class="top-marquee__sep">·</span> DROP 17/08/2026 <span class="top-marquee__sep">·</span> ',
        index_h1: "47PRIVATE — STREETWEAR ESPAGNOL · REVELATION 2026",
        footer_manifesto_heading: "ALWAYS FROM THE HEART",
        footer_manifesto_text: "On ne fait pas de vêtements pour tout le monde. Chaque pièce sort en quantités limitées, faite de l'intérieur et sans réassort. Si tu la portes, tu fais partie de la famille.",
        footer_manifesto_sign: "ALWAYS FROM THE HEART",
        legal_privacy: "Politique de Confidentialité",
        legal_terms: "Conditions Générales",
        legal_refund: "Politique de Remboursement",
        legal_shipping: "Politique de Livraison",
        legal_notice: "Mentions Légales",
        footer_stamp: "© 2026 47PRIVATE · TOUS DROITS RÉSERVÉS",
        popup_pre: "OFFRE EXCLUSIVE",
        popup_title_html: "REJOINS LE<br>CLUB PRIV47E",
        popup_sub_html: 'ABONNE-TOI ET OBTIENS <span class="popup-highlight">10% DE RÉDUCTION</span><br>SUR TA PREMIÈRE COMMANDE',
        popup_placeholder: "Ton adresse e-mail",
        popup_submit: "S'ABONNER",
        popup_legal: "* En t'abonnant, tu acceptes de recevoir des communications commerciales de 47Private. Tu peux te désabonner à tout moment.",
        popup_sending: "ENVOI...",
        popup_welcome: "✓ C'EST BON ! VÉRIFIE TES MAILS",
        popup_error: "ERREUR",
        btn_add_index: "AJOUTER",
        cart_title: "PANIER",
        cart_product: "PRODUIT",
        cart_qty: "QUANTITÉ",
        cart_total: "TOTAL",
        cart_remove: "SUPPRIMER",
        cart_subtotal: "SOUS-TOTAL",
        cart_shipping_note: "LES FRAIS DE PORT SONT CALCULÉS AU PAIEMENT.",
        cart_update: "METTRE À JOUR",
        cart_checkout: "PROCÉDER AU PAIEMENT",
        cart_empty_msg: "VOTRE PANIER EST VIDE.",
        cart_continue: "RETOURNER AU DROP",
        footer_subscribe_label: "OFFRES EXCLUSIVES",
        footer_subscribe_placeholder: "Votre email",
        footer_subscribe_btn: "S'INSCRIRE →",
        cookie_title: "PRIV47E // COOKIES",
        cookie_text: "NOUS UTILISONS DES COOKIES POUR MESURER LES PERFORMANCES DE LA BOUTIQUE ET AMÉLIORER VOTRE EXPÉRIENCE. LES ACCEPTEZ-VOUS ?",
        cookie_accept: "ACCEPTER",
        cookie_reject: "REFUSER",
        footer_subscribe_desc: "REJOIGNEZ LA FAMILLE. ACCÈS ANTICIPÉ AUX DROPS ET CONTENU EXCLUSIF DIRECTEMENT DANS VOTRE BOÎTE MAIL.",
        footer_sending: "ENVOI...",
        footer_welcome: "✓ INSCRIT",
        footer_error: "ERREUR",
        select_options: "CHOISIR LA TAILLE",
        add_error_generic: "ÉCHEC DE L'AJOUT",
        added_ok: "✓ ALL IN"
    }
};

const OPTION_TRANSLATIONS = {
    es: { capacidad: 'TALLA', talla: 'TALLA', size: 'TALLA', color: 'COLOR', colour: 'COLOR' },
    en: { capacidad: 'SIZE', talla: 'SIZE', size: 'SIZE', color: 'COLOR', colour: 'COLOR' },
    fr: { capacidad: 'TAILLE', talla: 'TAILLE', size: 'TAILLE', color: 'COULEUR', colour: 'COULEUR' }
};

const ALLOWED_HTML_KEYS = new Set([
    'marquee_heart',
    'marquee_shipping',
    'marquee_line_html',
    'popup_title_html',
    'popup_sub_html'
]);

const timeLabels = {
    es: ['Días',  'Horas', 'Min.', 'Seg.'],
    en: ['Days',  'Hours', 'Min.', 'Sec.'],
    fr: ['Jours', 'Heures','Min.', 'Sec.']
};

const ALLOWED_LANGS = new Set(['es', 'en', 'fr']);
const LANG_KEY = '47p_lang';
let currentLang = 'es';

const LAUNCH_DATE = new Date("2026-08-17T17:47:00+02:00").getTime();
let countdownInterval = null;

const REDUCE_MOTION = typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const FINE_POINTER = typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

function safeGetStoredLang() {
    try {
        const v = localStorage.getItem(LANG_KEY);
        return v && ALLOWED_LANGS.has(v) ? v : null;
    } catch { return null; }
}

function safeSetStoredLang(lang) {
    try { localStorage.setItem(LANG_KEY, lang); } catch {}
}

function startCountdown() {
    if (countdownInterval) clearInterval(countdownInterval);

    const elDays    = document.getElementById('days');
    const elHours   = document.getElementById('hours');
    const elMinutes = document.getElementById('minutes');
    const elSeconds = document.getElementById('seconds');

    function tick() {
        const distance = LAUNCH_DATE - Date.now();
        if (distance <= 0) {
            clearInterval(countdownInterval);
            countdownInterval = null;
            const cd = document.getElementById('countdown');
            if (cd && !cd.classList.contains('is-live')) {
                cd.classList.add('is-live');
                cd.innerHTML = '<a href="#archive-anchor" class="countdown-live" data-i18n="drop_live">SHOP NOW</a>';
            }
            return;
        }
        const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (elDays)    elDays.textContent    = String(days).padStart(2, '0');
        if (elHours)   elHours.textContent   = String(hours).padStart(2, '0');
        if (elMinutes) elMinutes.textContent = String(minutes).padStart(2, '0');
        if (elSeconds) elSeconds.textContent = String(seconds).padStart(2, '0');
    }

    tick();
    countdownInterval = setInterval(tick, 1000);

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            if (countdownInterval) {
                clearInterval(countdownInterval);
                countdownInterval = null;
            }
        } else if (!countdownInterval) {
            tick();
            countdownInterval = setInterval(tick, 1000);
        }
    });
}

function changeLang(lang) {
    if (!translations[lang]) return;
    currentLang = lang;
    safeSetStoredLang(lang);
    const dict = translations[lang];

    document.querySelectorAll('[data-i18n]').forEach(el => {
        const key   = el.getAttribute('data-i18n');
        const value = dict[key];
        if (value === undefined) return;

        if (ALLOWED_HTML_KEYS.has(key)) {
            el.innerHTML = value;
        } else {
            el.textContent = value;
        }
    });

    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
        const key = el.getAttribute('data-i18n-placeholder');
        const value = dict[key];
        if (value !== undefined) el.placeholder = value;
    });

    const optDict = OPTION_TRANSLATIONS[lang] || {};
    document.querySelectorAll('[data-i18n-option]').forEach(el => {
        const raw = el.getAttribute('data-i18n-option');
        const translated = optDict[raw];
        if (translated) el.textContent = translated;
    });

    const labels = timeLabels[lang];
    if (labels) {
        document.querySelectorAll('.time-label').forEach((label, i) => {
            if (labels[i] !== undefined) label.textContent = labels[i];
        });
    }

    translatePolicyPage(lang);

    document.documentElement.lang = lang;

    document.dispatchEvent(new CustomEvent('i47p:langchange', { detail: { lang } }));
}

function registerI18n(dict) {
    if (!dict || typeof dict !== 'object') return;
    Object.keys(dict).forEach(l => {
        if (!translations[l]) translations[l] = {};
        Object.assign(translations[l], dict[l]);
    });
    changeLang(currentLang);
}

function registerOptionI18n(dict) {
    if (!dict || typeof dict !== 'object') return;
    Object.keys(dict).forEach(l => {
        if (!OPTION_TRANSLATIONS[l]) OPTION_TRANSLATIONS[l] = {};
        Object.assign(OPTION_TRANSLATIONS[l], dict[l]);
    });
    changeLang(currentLang);
}

function registerTimeLabels(dict) {
    if (!dict || typeof dict !== 'object') return;
    Object.keys(dict).forEach(l => {
        if (Array.isArray(dict[l])) timeLabels[l] = dict[l].slice();
    });
    changeLang(currentLang);
}

function registerHtmlKeys(keys) {
    if (!Array.isArray(keys)) return;
    keys.forEach(k => ALLOWED_HTML_KEYS.add(k));
}

function t(key, fallback) {
    const d = translations[currentLang] || translations.es || {};
    const v = d[key];
    return v !== undefined ? v : fallback;
}

window.I47P = {
    registerI18n,
    registerOptionI18n,
    registerTimeLabels,
    registerHtmlKeys,
    changeLang,
    getLang: function () { return currentLang; },
    t,
    EVENT_LANGCHANGE: 'i47p:langchange'
};

const POLICY_TRANSLATIONS = {
    es: {
        'privacy-policy': 'Política de Privacidad',
        'terms-of-service': 'Términos y Condiciones',
        'refund-policy': 'Política de Devoluciones',
        'shipping-policy': 'Política de Envíos',
        'legal-notice': 'Aviso Legal'
    },
    en: {
        'privacy-policy': 'Privacy Policy',
        'terms-of-service': 'Terms & Conditions',
        'refund-policy': 'Refund Policy',
        'shipping-policy': 'Shipping Policy',
        'legal-notice': 'Legal Notice'
    },
    fr: {
        'privacy-policy': 'Politique de Confidentialité',
        'terms-of-service': 'Conditions Générales',
        'refund-policy': 'Politique de Remboursement',
        'shipping-policy': 'Politique de Livraison',
        'legal-notice': 'Mentions Légales'
    }
};

function translatePolicyPage(lang) {
    const titleEl = document.querySelector('.shopify-policy__title h1') || document.querySelector('.shopify-policy__title');
    if (!titleEl) return;

    const path = window.location.pathname;
    const policyDict = POLICY_TRANSLATIONS[lang];
    if (!policyDict) return;

    for (const [slug, title] of Object.entries(policyDict)) {
        if (path.includes(slug)) {
            titleEl.textContent = title;
            break;
        }
    }
}

let scrollObserver = null;

function initScrollObserver() {
    if (scrollObserver) scrollObserver.disconnect();

    if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.scroll-item').forEach(el => el.classList.add('in-view'));
        return;
    }

    scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('in-view');
            scrollObserver.unobserve(entry.target);
        });
    }, { threshold: 0.15, rootMargin: '0px 0px 100px 0px' });

    document.querySelectorAll('.scroll-item').forEach(item => scrollObserver.observe(item));
}

function initLogo3D() {
    const wrappers = document.querySelectorAll('.logo-3d-wrap');
    if (!wrappers.length || REDUCE_MOTION || !FINE_POINTER) return;

    const MAX_TILT   = 28;
    const MAX_SHADOW = 40;

    wrappers.forEach(wrapper => {
        const img = wrapper.querySelector('.logo-3d-img');
        if (!img) return;

        const isNav = img.id === 'nav-logo';
        let pendingX = 0;
        let pendingY = 0;
        let rafId    = 0;
        let active   = false;

        function applyFromState() {
            rafId = 0;
            const x = pendingX;
            const y = pendingY;
            const rotY =  x * MAX_TILT;
            const rotX = -y * MAX_TILT;
            const shX  =  x * MAX_SHADOW;
            const shY  =  y * MAX_SHADOW;

            img.style.transform =
                `rotateX(${rotX}deg) rotateY(${rotY}deg) scale(1.06)`;

            if (isNav) {
                img.style.filter =
                    `invert(1) ` +
                    `drop-shadow(${-shX * 0.5}px ${-shY * 0.5}px 18px rgba(193,18,31,0.55)) ` +
                    `drop-shadow(${shX * 0.3}px ${shY * 0.3}px 35px rgba(0,0,0,0.6))`;
            } else {
                img.style.filter =
                    `drop-shadow(${-shX * 0.5}px ${-shY * 0.5}px 20px rgba(193,18,31,0.50)) ` +
                    `drop-shadow(${shX * 0.3}px ${shY * 0.3}px 40px rgba(0,0,0,0.65))`;
            }
        }

        function schedule(clientX, clientY) {
            const rect = wrapper.getBoundingClientRect();
            pendingX = ((clientX - rect.left) / rect.width)  * 2 - 1;
            pendingY = ((clientY - rect.top)  / rect.height) * 2 - 1;
            if (!rafId) rafId = requestAnimationFrame(applyFromState);
        }

        function start() {
            active = true;
            wrapper.classList.add('is-tilting');
        }

        function reset() {
            active = false;
            wrapper.classList.remove('is-tilting');
            if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
            img.style.transform = '';
            img.style.filter    = '';
        }

        wrapper.addEventListener('mouseenter', start);
        wrapper.addEventListener('mousemove', (e) => {
            if (!active) start();
            schedule(e.clientX, e.clientY);
        }, { passive: true });
        wrapper.addEventListener('mouseleave', reset);
    });
}

function initHeroCarousel() {
    const carousel = document.getElementById('hero-carousel');
    if (!carousel) return;

    const slides = Array.from(carousel.querySelectorAll('.hero-slide'));
    if (slides.length === 0) return;

    let current = slides.findIndex(slide => slide.classList.contains('is-active'));
    if (current === -1) current = 0;
    slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === current);
    });

    if (REDUCE_MOTION || slides.length < 2) return;

    const INTERVAL_MS = 3500;
    let timer = null;

    function advance() {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
    }

    function start() {
        if (timer !== null || document.hidden) return;
        timer = window.setInterval(advance, INTERVAL_MS);
    }

    function stop() {
        if (timer === null) return;
        window.clearInterval(timer);
        timer = null;
    }

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
    });

    if (FINE_POINTER) {
        carousel.addEventListener('mouseenter', stop);
        carousel.addEventListener('mouseleave', start);
    }

    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        const enfocado = document.activeElement;
        if (enfocado && carousel.contains(enfocado) && typeof enfocado.blur === 'function') {
            enfocado.blur();
        }
        stop();
        start();
    });

    start();
}

function initTopBar() {
    const viewport = document.getElementById('top-bar-viewport');
    if (!viewport) return;

    const mensajes = Array.from(viewport.querySelectorAll('.top-bar__msg'));
    if (!mensajes.length) return;

    const prevBtn = document.getElementById('top-bar-prev');
    const nextBtn = document.getElementById('top-bar-next');
    const INTERVAL_MS = 4000;
    let current = Math.max(0, mensajes.findIndex(m => m.classList.contains('is-active')));
    let timer = null;

    mensajes.forEach((msg, index) => msg.classList.toggle('is-active', index === current));

    if (mensajes.length < 2) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        return;
    }

    function mostrar(indice) {
        mensajes[current].classList.remove('is-active');
        current = (indice + mensajes.length) % mensajes.length;
        mensajes[current].classList.add('is-active');
    }

    function detener() {
        if (timer === null) return;
        window.clearInterval(timer);
        timer = null;
    }

    function arrancar() {
        if (REDUCE_MOTION || timer !== null || document.hidden) return;
        timer = window.setInterval(() => mostrar(current + 1), INTERVAL_MS);
    }

    function manual(paso) {
        detener();
        mostrar(current + paso);
        arrancar();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => manual(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => manual(1));

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) detener();
        else arrancar();
    });

    arrancar();
}

function handleSubscriptionForm(formId, inputId, btnId, config) {
    const form = document.getElementById(formId);
    const input = document.getElementById(inputId);
    const btn = document.getElementById(btnId);
    if (!form || !input || !btn) return;

    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form);
    }

    form.addEventListener('submit', () => {
        const email = input.value.trim();
        if (!email) return;

        const dict = translations[currentLang] || translations.es;
        btn.textContent = dict[config.sending] || 'ENVIANDO...';
        btn.disabled = true;

        const msgEl = form.querySelector('.form-err-msg');
        if (msgEl) msgEl.remove();

        try { sessionStorage.setItem('47p_sub_pending', formId); } catch {}
    });
}

function initSubscribeConfirmation() {
    let params;
    try { params = new URLSearchParams(window.location.search); } catch { return; }
    if (params.get('customer_posted') !== 'true') return;

    let pendiente = null;
    try { pendiente = sessionStorage.getItem('47p_sub_pending'); } catch {}
    try { sessionStorage.removeItem('47p_sub_pending'); } catch {}
    try { localStorage.setItem('47p_popup_shown', 'true'); } catch {}

    const dict = translations[currentLang] || translations.es;
    const mensaje = dict.popup_welcome || '✓ ¡DENTRO! REVISA TU CORREO';
    const toastEl = document.getElementById('enh-toast');
    if (toastEl) {
        toastEl.textContent = mensaje;
        toastEl.classList.add('is-shown');
        setTimeout(() => toastEl.classList.remove('is-shown'), 5000);
    }

    if (pendiente === 'footer-subscribe-form') {
        const footerBtn = document.getElementById('footer-subscribe-btn');
        const footerInput = document.getElementById('footer-email-input');
        if (footerBtn) footerBtn.textContent = dict.footer_welcome || '✓ SUSCRITO';
        if (footerInput) footerInput.disabled = true;
    }

    params.delete('customer_posted');
    const consulta = params.toString();
    history.replaceState(null, '', window.location.pathname + (consulta ? '?' + consulta : '') + window.location.hash);
}

const ModalScrollLock = (function () {
    let count = 0;
    return {
        lock() {
            count++;
            document.body.style.overflow = 'hidden';
        },
        unlock() {
            count = Math.max(0, count - 1);
            if (count === 0) document.body.style.overflow = '';
        }
    };
})();

function initEmailPopup() {
    const overlay = document.getElementById('email-popup-overlay');
    const closeBtn = document.getElementById('email-popup-close');
    if (!overlay || !closeBtn) return;

    const POPUP_STORAGE_KEY = '47p_popup_shown';
    let isVisible = false;
    let lastFocused = null;

    function showPopup() {
        overlay.hidden = false;
        void overlay.offsetWidth;
        overlay.classList.add('visible');
        ModalScrollLock.lock();
        isVisible = true;
        lastFocused = document.activeElement;
        closeBtn.focus();
    }

    function hidePopup() {
        if (!isVisible) return;
        overlay.classList.remove('visible');
        ModalScrollLock.unlock();
        try { localStorage.setItem(POPUP_STORAGE_KEY, 'true'); } catch {}
        isVisible = false;
        if (lastFocused && typeof lastFocused.focus === 'function') {
            lastFocused.focus();
        }
        lastFocused = null;
        setTimeout(() => {
            if (!overlay.classList.contains('visible')) overlay.hidden = true;
        }, 450);
    }

    closeBtn.addEventListener('click', hidePopup);

    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) hidePopup();
    });

    overlay.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !isVisible) return;
        const focusables = Array.from(
            overlay.querySelectorAll('button, input, select, textarea, a[href]')
        ).filter(el => !el.disabled);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isVisible) hidePopup();
    });

    handleSubscriptionForm('email-subscribe-form', 'email-input', 'email-popup-submit', {
        sending: 'popup_sending',
        success: 'popup_welcome',
        error: 'popup_error',
        addClass: 'sent',
        onSuccess: () => {
            try { localStorage.setItem(POPUP_STORAGE_KEY, 'true'); } catch {}
            setTimeout(hidePopup, 2500);
        }
    });

    let alreadyShown = false;
    try { alreadyShown = !!localStorage.getItem(POPUP_STORAGE_KEY); } catch {}
    if (!alreadyShown) {
        setTimeout(showPopup, 5000);
    }
}

function initFooterSubscribe() {
    handleSubscriptionForm('footer-subscribe-form', 'footer-email-input', 'footer-subscribe-btn', {
        sending: 'footer_sending',
        success: 'footer_welcome',
        error: 'footer_error'
    });
}

async function addCurrentFormToCart(form) {
    const formData = new FormData(form);

    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
    });

    if (!res.ok) {
        let msg = 'Add to cart failed';
        try {
            const err = await res.json();
            if (err && err.description) msg = err.description;
            else if (err && err.message) msg = err.message;
        } catch {}
        const e = new Error(msg);
        e.status = res.status;
        throw e;
    }

    await res.json();

    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!cartRes.ok) return null;
    return await cartRes.json();
}

function updateCartBadge(cart) {
    const badge = document.getElementById('cart-badge');
    if (!badge || !cart) return;
    const raw = cart.item_count;
    const count = typeof raw === 'number' ? raw : parseInt(raw, 10);
    if (isNaN(count)) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'inline-block' : 'none';
}

async function syncCartBadge() {
    try {
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        updateCartBadge(cart);
    } catch {}
}

function initCartBadgeSync() {
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) syncCartBadge();
    });
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) syncCartBadge();
    });
}

function validateVariantSelection(form) {
    const variantSelect = form.querySelector('select[name="id"]');
    if (!variantSelect) return { ok: true };

    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOption || selectedOption.disabled) {
        return { ok: false, reason: 'unavailable' };
    }

    const optionBlocks = form.querySelectorAll('.option-block');
    let requiredCount = 0;
    optionBlocks.forEach(block => {
        if (block.querySelector('.option-pill')) requiredCount++;
    });

    if (requiredCount === 0) return { ok: true };

    let selectedCount = 0;
    optionBlocks.forEach(block => {
        if (!block.querySelector('.option-pill')) return;
        if (block.querySelector('.option-pill.is-active')) selectedCount++;
    });

    if (selectedCount < requiredCount) {
        return { ok: false, reason: 'incomplete' };
    }

    return { ok: true };
}

function flashOptionBlocks(form) {
    form.querySelectorAll('.option-block').forEach(block => {
        if (!block.querySelector('.option-pill')) return;
        if (block.querySelector('.option-pill.is-active')) return;
        block.classList.remove('needs-selection');
        void block.offsetWidth;
        block.classList.add('needs-selection');
        setTimeout(() => block.classList.remove('needs-selection'), 1600);
    });
}

function initAddToCartAjax() {
    document.querySelectorAll('.product-form, .product-form-detail').forEach(form => {
        if (form.dataset.cartBound) return;
        form.dataset.cartBound = 'true';

        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (isDropLocked()) return;

            const btn = form.querySelector('.btn-add-cart, .btn-buy-now[data-action="add"]')
                     || form.querySelector('.btn-add-cart, .btn-buy-now');
            if (!btn || btn.disabled) return;

            const textEl = btn.querySelector('.btn-buy-now__text') || btn;
            const originalText = textEl.textContent;

            const check = validateVariantSelection(form);
            if (!check.ok) {
                flashOptionBlocks(form);
                textEl.textContent = check.reason === 'unavailable'
                    ? (translations[currentLang]?.sold_out || 'AGOTADO')
                    : (translations[currentLang]?.select_options || 'SELECCIONA TALLA');
                setTimeout(() => { textEl.textContent = originalText; }, 2200);
                return;
            }

            btn.disabled = true;
            textEl.textContent = '...';

            try {
                const cart = await addCurrentFormToCart(form);
                textEl.textContent = translations[currentLang]?.added_ok || '✓ ALL IN';
                btn.classList.add('is-added');
                updateCartBadge(cart);

                const cartIcon = document.getElementById('simulated-cart');
                if (cartIcon && !REDUCE_MOTION) {
                    cartIcon.classList.add('cart-pop');
                    setTimeout(() => cartIcon.classList.remove('cart-pop'), 600);
                }

                setTimeout(() => {
                    textEl.textContent = originalText;
                    btn.classList.remove('is-added');
                    btn.disabled = false;
                }, 2500);
            } catch (err) {
                textEl.textContent = translations[currentLang]?.add_error_generic || 'ERROR';
                setTimeout(() => {
                    textEl.textContent = originalText;
                    btn.disabled = false;
                }, 2200);
            }
        });
    });
}

function initBuyNowExpress() {
    const expressBtn = document.getElementById('btn-buy-now');
    const form = document.getElementById('product-form-detail');
    if (!expressBtn || !form || expressBtn.dataset.expressBound) return;
    expressBtn.dataset.expressBound = 'true';

    expressBtn.addEventListener('click', async () => {
        if (expressBtn.disabled || isDropLocked()) return;
        const span = expressBtn.querySelector('span');
        const originalText = span.textContent;

        const check = validateVariantSelection(form);
        if (!check.ok) {
            flashOptionBlocks(form);
            span.textContent = check.reason === 'unavailable'
                ? (translations[currentLang]?.sold_out || 'AGOTADO')
                : (translations[currentLang]?.select_options || 'SELECCIONA TALLA');
            setTimeout(() => { span.textContent = originalText; }, 2200);
            return;
        }

        expressBtn.disabled = true;
        span.textContent = '...';

        try {
            await addCurrentFormToCart(form);
            window.location.href = '/checkout';
        } catch {
            span.textContent = translations[currentLang]?.add_error_generic || 'ERROR';
            setTimeout(() => {
                span.textContent = originalText;
                expressBtn.disabled = false;
            }, 2200);
        }
    });

    window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        const span = expressBtn.querySelector('span');
        if (span && span.textContent === '...') {
            span.textContent = t('buy_now', 'COMPRAR AHORA');
            expressBtn.disabled = false;
        }
    });
}

function initProductPage() {
    const form = document.getElementById('product-form-detail');
    if (!form) return;

    const variantSelect = document.getElementById('product-variant-select');
    const strip         = document.getElementById('gallery-strip');
    const slides        = strip ? Array.from(strip.querySelectorAll('.gallery-strip__slide img')) : [];
    const priceAmount   = document.getElementById('product-price-amount');
    const btnAddPrice   = document.getElementById('btn-add-cart-price');
    const btnAdd        = document.getElementById('btn-add-cart');
    const thumbs        = document.querySelectorAll('.product-gallery__thumb');
    const qtyInput      = document.getElementById('product-qty');
    const pills         = form.querySelectorAll('.option-pill');
    const optionBlocks  = form.querySelectorAll('.option-block');

    const selected = [];
    optionBlocks.forEach((block, idx) => {
        const active = block.querySelector('.option-pill.is-active');
        if (active) selected[idx] = active.dataset.optionValue;
    });

    function allSelected() {
        let required = 0;
        let filled = 0;
        optionBlocks.forEach((block, idx) => {
            if (!block.querySelector('.option-pill')) return;
            required++;
            if (selected[idx] !== undefined) filled++;
        });
        return required === filled;
    }

    function findVariant(values) {
        return Array.from(variantSelect.options).find(opt => {
            const opts = (opt.dataset.variantOptions || '').split('||');
            return values.every((v, i) => v === undefined || opts[i] === v);
        });
    }

    function refreshAvailability() {
        optionBlocks.forEach((block, blockIdx) => {
            block.querySelectorAll('.option-pill').forEach(pill => {
                const test = [...selected];
                test[blockIdx] = pill.dataset.optionValue;
                const match = findVariant(test);
                const available = match && match.dataset.available === 'true';
                pill.disabled = !available;
            });
        });
    }

    function marcarThumbActiva(indice) {
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === indice));
    }

    function irASlide(indice, suave) {
        if (!strip || !slides.length) return;
        const destino = Math.max(0, Math.min(indice, slides.length - 1));
        const left    = strip.clientWidth * destino;
        const inicio  = strip.scrollLeft;
        const smooth  = suave && !REDUCE_MOTION;
        strip.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        // Algunos motores Chromium ignoran scrollTo({behavior:'smooth'}) cuando el
        // scroll-snap es mandatory: si a los 260 ms no se ha movido, forzamos la posición.
        if (smooth && Math.abs(left - inicio) > 4) {
            setTimeout(() => {
                if (Math.abs(strip.scrollLeft - inicio) < 4) strip.scrollLeft = left;
            }, 260);
        }
        marcarThumbActiva(destino);
    }

    function indiceDeSlidePorSrc(src) {
        if (!src) return -1;
        const objetivo = new URL(src, window.location.href).href;
        return slides.findIndex(img => new URL(img.getAttribute('src'), window.location.href).href === objetivo);
    }

    function updateVariant() {
        const match = findVariant(selected);
        if (!match) return;

        variantSelect.value = match.value;

        if (priceAmount && match.dataset.price) priceAmount.textContent = match.dataset.price;
        if (btnAddPrice && match.dataset.price) btnAddPrice.textContent = match.dataset.price;

        if (match.dataset.image) {
            const indice = indiceDeSlidePorSrc(match.dataset.image);
            if (indice !== -1) irASlide(indice, true);
        }

        const available = match.dataset.available === 'true';
        const complete  = allSelected();

        if (btnAdd) {
            const dropLocked = isDropLocked();
            btnAdd.disabled = dropLocked || !available || !complete;
            const textEl = btnAdd.querySelector('.btn-buy-now__text');
            if (textEl) {
                if (dropLocked) {
                    textEl.textContent = translations[currentLang]?.drop_locked || 'DISPONIBLE 17/08 · 17:47';
                } else if (!complete) {
                    textEl.textContent = translations[currentLang]?.select_options || 'SELECCIONA TALLA';
                } else if (available) {
                    textEl.textContent = translations[currentLang]?.add_to_cart || 'AÑADIR AL CARRITO';
                } else {
                    textEl.textContent = translations[currentLang]?.sold_out || 'AGOTADO';
                }
            }
        }
        const expressBtn = document.getElementById('btn-buy-now');
        if (expressBtn) expressBtn.disabled = isDropLocked() || !available || !complete;
    }

    pills.forEach(pill => {
        pill.addEventListener('click', () => {
            if (pill.disabled) return;
            const blockIdx = parseInt(pill.dataset.optionPosition, 10);
            const value    = pill.dataset.optionValue;

            const block = pill.closest('.option-block');
            block.classList.remove('needs-selection');
            block.querySelectorAll('.option-pill').forEach(p => {
                p.classList.remove('is-active');
                p.setAttribute('aria-checked', 'false');
            });
            pill.classList.add('is-active');
            pill.setAttribute('aria-checked', 'true');

            selected[blockIdx] = value;
            updateVariant();
            refreshAvailability();
        });
    });

    form.querySelectorAll('.option-block__values').forEach(group => {
        group.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
            const groupPills = Array.from(group.querySelectorAll('.option-pill'));
            const idx = groupPills.indexOf(document.activeElement);
            if (idx === -1) return;
            e.preventDefault();
            const dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
            let next = idx;
            for (let i = 0; i < groupPills.length; i++) {
                next = (next + dir + groupPills.length) % groupPills.length;
                if (!groupPills[next].disabled) break;
            }
            if (groupPills[next].disabled) return;
            groupPills[next].focus();
            groupPills[next].click();
        });
    });

    thumbs.forEach((thumb, indice) => {
        thumb.addEventListener('click', () => {
            irASlide(indice, true);
        });
    });

    if (strip && slides.length > 1) {
        let rafStrip = 0;
        strip.addEventListener('scroll', () => {
            if (rafStrip) return;
            rafStrip = requestAnimationFrame(() => {
                rafStrip = 0;
                const ancho = Math.max(1, strip.clientWidth);
                marcarThumbActiva(Math.round(strip.scrollLeft / ancho));
            });
        }, { passive: true });
    }

    document.querySelectorAll('[data-qty-action]').forEach(btn => {
        btn.addEventListener('click', () => {
            if (!qtyInput) return;
            let v = parseInt(qtyInput.value, 10) || 1;
            const max = parseInt(qtyInput.max, 10) || 10;
            const min = parseInt(qtyInput.min, 10) || 1;
            if (btn.dataset.qtyAction === 'increment') v = Math.min(v + 1, max);
            if (btn.dataset.qtyAction === 'decrement') v = Math.max(v - 1, min);
            qtyInput.value = v;
        });
    });

    if (qtyInput) {
        qtyInput.addEventListener('change', () => {
            const max = parseInt(qtyInput.max, 10) || 10;
            const min = parseInt(qtyInput.min, 10) || 1;
            let v = parseInt(qtyInput.value, 10);
            if (isNaN(v)) v = min;
            qtyInput.value = Math.min(Math.max(v, min), max);
        });
    }

    updateVariant();
    refreshAvailability();
}

function initFooterSparkles() {
    const container = document.getElementById('footer-logo-container');
    if (!container || REDUCE_MOTION) return;

    let sparkleInterval = null;

    function spawnSparkle() {
        const sparkle = document.createElement('div');
        sparkle.classList.add('sparkle');

        const capacidad = Math.random() * 12 + 6;
        sparkle.style.width = `${capacidad}px`;
        sparkle.style.height = `${capacidad}px`;

        const x = Math.random() * 100;
        const y = Math.random() * 100;
        sparkle.style.left = `${x}%`;
        sparkle.style.top = `${y}%`;

        container.appendChild(sparkle);

        setTimeout(() => {
            if (sparkle.parentNode === container) sparkle.remove();
        }, 1200);
    }

    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !sparkleInterval) {
                    sparkleInterval = setInterval(spawnSparkle, 500);
                } else if (!entry.isIntersecting && sparkleInterval) {
                    clearInterval(sparkleInterval);
                    sparkleInterval = null;
                }
            });
        }, { threshold: 0.1 });
        io.observe(container);
    } else {
        sparkleInterval = setInterval(spawnSparkle, 500);
    }
}

function updateConsent(status) {
    window.dataLayer = window.dataLayer || [];
    const granted = status === 'accepted' ? 'granted' : 'denied';
    const payload = {
        ad_storage: granted,
        ad_user_data: granted,
        ad_personalization: granted,
        analytics_storage: granted
    };
    if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', payload);
    } else {
        (function () { window.dataLayer.push(arguments); })('consent', 'update', payload);
    }
    if (window.Shopify && window.Shopify.customerPrivacy) {
        try {
            window.Shopify.customerPrivacy.setTrackingConsent(status === 'accepted', () => {});
        } catch {}
    }
}

function initCookieBanner() {
    const banner = document.getElementById('cookie-banner');
    const btnAccept = document.getElementById('cookie-accept');
    const btnReject = document.getElementById('cookie-reject');
    if (!banner || !btnAccept || !btnReject) return;

    const cookieKey = '47p_cookie_consent';
    let stored = null;
    try { stored = localStorage.getItem(cookieKey); } catch {}

    if (!stored) {
        setTimeout(() => {
            banner.hidden = false;
            void banner.offsetWidth;
            banner.classList.add('is-visible');
        }, 1000);
    }

    function closeBanner(status) {
        try { localStorage.setItem(cookieKey, status); } catch {}
        banner.classList.remove('is-visible');
        setTimeout(() => banner.hidden = true, 400);
        updateConsent(status);
    }

    btnAccept.addEventListener('click', () => closeBanner('accepted'));
    btnReject.addEventListener('click', () => closeBanner('rejected'));
}

function initAccordion() {
    document.querySelectorAll('.accordion-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const block = btn.closest('.accordion-block');
            const isOpen = block.classList.contains('is-open');
            const icon = btn.querySelector('.accordion-icon');

            if (isOpen) {
                block.classList.remove('is-open');
                btn.setAttribute('aria-expanded', 'false');
                if (icon) icon.textContent = '+';
            } else {
                block.classList.add('is-open');
                btn.setAttribute('aria-expanded', 'true');
                if (icon) icon.textContent = '−';
            }
        });
    });
}

function initNavScroll() {
    const nav = document.getElementById('site-nav');
    if (!nav) return;
    const threshold = 40;
    let ticking = false;
    function update() {
        ticking = false;
        if (window.scrollY > threshold) nav.classList.add('is-scrolled');
        else nav.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });
    update();
}

function isDropLocked() {
    return Date.now() < LAUNCH_DATE;
}

function initDropGate() {
    const addBtn = document.getElementById('btn-add-cart');
    const buyBtn = document.getElementById('btn-buy-now');
    if (!addBtn && !buyBtn) return;
    if (!isDropLocked()) return;

    if (addBtn) {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('is-drop-locked');
        const textEl = addBtn.querySelector('.btn-buy-now__text');
        if (textEl) textEl.setAttribute('data-i18n', 'drop_locked');
        const priceEl = document.getElementById('btn-add-cart-price');
        if (priceEl) priceEl.style.display = 'none';
    }

    if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.setAttribute('aria-disabled', 'true');
        buyBtn.classList.add('is-drop-locked');
        const label = buyBtn.querySelector('span[data-i18n="buy_now"]');
        if (label) label.setAttribute('data-i18n', 'drop_soon');
        const arrow = buyBtn.querySelector('.btn-buy-express__arrow');
        if (arrow) arrow.style.display = 'none';
    }

    if (!document.getElementById('drop-gate-style')) {
        const style = document.createElement('style');
        style.id = 'drop-gate-style';
        style.textContent = '.btn-buy-now.is-drop-locked,.btn-buy-express.is-drop-locked{opacity:0.7;cursor:not-allowed;filter:grayscale(0.25)}';
        document.head.appendChild(style);
    }

    changeLang(currentLang);

    const remaining = LAUNCH_DATE - Date.now();
    if (remaining > 0 && remaining <= 2147483647) {
        setTimeout(function () { window.location.reload(); }, remaining + 1000);
    }
}

function init() {
    const storedLang = safeGetStoredLang();
    const browserLang = (navigator.language || 'es').slice(0, 2).toLowerCase();
    const initialLang = storedLang || (ALLOWED_LANGS.has(browserLang) ? browserLang : 'es');
    changeLang(initialLang);

    const langSelect = document.getElementById('lang-select');
    if (langSelect) {
        langSelect.value = initialLang;
        langSelect.addEventListener('change', (e) => {
            const v = e.target.value;
            if (ALLOWED_LANGS.has(v)) changeLang(v);
        });
    }

    startCountdown();
    initNavScroll();
    initTopBar();
    initLogo3D();
    initHeroCarousel();
    initScrollObserver();
    initSubscribeConfirmation();
    initEmailPopup();
    initProductPage();
    initAddToCartAjax();
    initBuyNowExpress();
    initDropGate();
    initFooterSparkles();
    initFooterSubscribe();
    initCookieBanner();
    initAccordion();
    initCartBadgeSync();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}

})();